import React, { useState, useEffect } from 'react'
import { EmailInputTypes } from './types'

export const EmailInput = ({
  className,
  label,
  name,
  tabIndex,
  placeholder,
  required,
  value,
  onChange,
  requiredMessage,
  validationMsg,
}: EmailInputTypes) => {
  const [validationErrorMessage, setValidationErrorMessage] = useState<string | undefined>(validationMsg)

  useEffect(() => {
    setValidationErrorMessage(validationMsg)
  }, [validationMsg])

  const handleBlur = () => {
    if ((!value || value.length === 0) && required) {
      setValidationErrorMessage(requiredMessage)
    } else {
      setValidationErrorMessage(undefined)
    }
  }

  return (
    <div className="flex flex-col mb-12">
      {label && <label htmlFor={name} className="text-base font-medium">{label}</label>}
      <input
        tabIndex={tabIndex}
        className={`${className}`}
        type="email"
        name={name}
        value={value}
        placeholder={placeholder}
        onBlur={handleBlur}
        onChange={onChange}
        required={required}
      />
      {validationErrorMessage && (
        <p className="text-cinnamon text-base py-4">{validationErrorMessage}</p>
      )}
    </div>
  )
}
